import React, { useRef, useState } from 'react';
import { Col, Row } from 'react-flexbox-grid';
import MultiselectExtension from "../MultiselectExtension";
import {updateProjectDetails} from '../../api';
import {spinnerOff, spinnerOn} from "../Spinner";
import { Input } from 'antd';

function ProjectReasonDialog({ reasonCodes, onClose, newCloseDate, project, setTempProject }) {

    const [selectedReasonCodes, setSelectedReasonCodes] = useState(project.closeReasonCodes);
    const[closeReasonNotes,setCloseReasonNotes]=useState(project.closeReasonNotes)
    const [saveDisabled, setSaveDisabled] = useState(project.closeReasonCodes == null ? true : false);

    function handReasonChange(optionsList, selectedItem)
    {
        let reasons = optionsList.sort(function(t1,t2){return(t1.id-t2.id)}).map(item => {
            return item.reasonCode;
        }).join(', ');
        setSelectedReasonCodes(reasons);
        setSaveDisabled(optionsList.length > 0 ? false : true);
    }

     /*
     for reset Edit Date button 
     */

    
    const selectedReasonRef = useRef() 
    const resetSelectedReason = () => {
    
        selectedReasonRef.current.resetSelectedValues();  
        handReasonChange([])
    };

    const handleCloseReasonNotes = (e) => {

       setCloseReasonNotes(e.target.value)
    }
   
    return (
        <div className='react-confirm-alert-body'>
            <h4>Reason for Modified Expected Close Date</h4>
            <br/>
            <div className='edit-dialog--task'>
                <Row style={{ textAlign: 'left' }}>
                    <Col xs={10} md={10} lg={10}>
                        Select the reason(s) for modifying the Expected Close Date beyond the default value of 45 Days after the In-Service Date.
                    </Col>
                </Row>
                <br/>
                <Row style={{ textAlign: 'left' }}> 
                    {/* <Col xs={10} md={10} lg={10}>{selectedReasonCodes} </Col> */}
                </Row>
                <Row style={{ textAlign: 'left' }}>
                    <Col xs={10} md={10} lg={10}>
                        <MultiselectExtension options={reasonCodes}
                                              selectedValues={project.closeReasonCodes===null ? null : reasonCodes.filter(t=>
                                                  project.closeReasonCodes.includes(t.reasonCode))}
                                              onSelect={handReasonChange}
                                              onRemove={handReasonChange}
                                              showCheckbox={true}
                                              displayValue="reasonCode"
                            placeholder="Must choose at least one option"
                            ref={selectedReasonRef}
                        resetSelectField={resetSelectedReason}
                        />
                        
                    </Col>
                    {(project.closeReasonCodes || selectedReasonCodes) &&<Col xs={10} md={10} lg={10} className='d-flex align-items-center' >
                        <span className='ml-2 font-weight-bold'>
                            Notes:
                        </span>
                        <Col className='pl-2 w-100'>
                            <Input
                                onChange={handleCloseReasonNotes}
                                value={closeReasonNotes}
                                className="chipInputWrapper"
                                maxLength={1200}
                                
                            />
                        </Col>
                    </Col>}
                </Row>
            </div>
            <br />
            <Row style={{ textAlign: 'left' }}>
                <Col xs={8} md={8} lg={8}>
                    <button disabled={selectedReasonCodes===null || selectedReasonCodes===''}
                            className='btn btn-primary start-5'
                            onClick={async () => {
                                const newAttributes = {
                                    expectedCloseDate: newCloseDate!==null ? newCloseDate : project.expectedCloseDate,
                                    closeReasonCodes: selectedReasonCodes,
                                    closeReasonNotes:closeReasonNotes
                                };
                                const updatedProject = {
                                    ...project,
                                    ...newAttributes
                                };
                                spinnerOn();
                                let saveProject = await updateProjectDetails(updatedProject);
                                spinnerOff();
                                setTempProject(saveProject);
                                onClose();
                            }}
                    >
                        Save
                    </button>
                    <button disabled={false}
                            className='btn btn-primary start-5'
                            onClick={() => {
                                onClose();
                            }}
                    >
                        Cancel
                    </button>
                </Col>
             </Row>
        </div>
    );
}

export default ProjectReasonDialog;
